import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { motion } from "framer-motion";

// Content renders fully visible by default (SSR/prerender/no-JS safe).
// Animations switch on only after mount, and never for reduced-motion users.
export const useEnhanced = () => {
  const [on, setOn] = useState(false);
  useEffect(() => {
    if (!window.matchMedia("(prefers-reduced-motion: reduce)").matches) setOn(true);
  }, []);
  return on;
};

export const Reveal = ({ children, delay = 0, className = "", y = 32 }) => {
  const enhance = useEnhanced();
  const { pathname } = useLocation();
  // Owner's directive: no scroll/fade animations on the Home page.
  if (!enhance || pathname === "/") return <div className={className}>{children}</div>;
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-70px" }}
      transition={{ duration: 0.8, delay, ease: [0.16, 1, 0.3, 1] }}
    >
      {children}
    </motion.div>
  );
};

export const Eyebrow = ({ children }) => (
  <span className="inline-flex items-center gap-2.5 font-mono text-[10px] sm:text-xs tracking-[0.3em] uppercase text-accent">
    <span className="h-px w-8 bg-accent/60" aria-hidden="true" />
    {children}
  </span>
);
